export default __webpack_public_path__ + "static/media/slide3_w_bg.23c5eaf1.png";